<template>
  <div class="search-list">
    <input
      class="text--m"
      type="text"
      :placeholder="localize(placeholder)"
      v-model="search"
      @focus="activeOptions = true"
      @blur="blurHandler"
      @keydown="keypressHandler"
      @keydown.down="keydownHandler"
      @keydown.up="keyupHandler"
      @keydown.enter="enterHandler"
    />
    <transition name="overlay-down" appear>
      <ul v-if="activeOptions" class="search-list--options" ref="options">
        <li
          v-for="(country, index) in filteredCountries"
          :key="country.title"
          v-html="parseCountryLabel(country.title)"
          :class="[activeOptionIndex === index ? 'active' : '']"
          @click="updateSearch(country.title)"
        ></li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["value"],
  data() {
    return {
      placeholder: "type_your_country",
      activeOptions: false,
      activeOptionIndex: -1
    };
  },
  computed: {
    search: {
      get() {
        return this.$store.state.search;
      },
      set(value) {
        this.$store.commit("UPDATE_SEARCH", value);
      }
    },
    filteredCountries() {
      if (this.search.length < 1) {
        return this.countries;
      }
      let filter = _.filter(this.countries, country => {
        return (
          country.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
          this.search.toLowerCase().indexOf(country.title.toLowerCase()) > -1
        );
      });

      console.log("1 FILTER>", filter.length);

      if (!filter.length) {
        filter = _.filter(this.countries, country => {
          return (
            country.title
              .toLowerCase()
              .indexOf(this.search.substr(0, 2).toLowerCase()) > -1
          );
        });
        console.log("2 FILTER>", filter.length);
      }
      return filter.length ? filter : this.countries;
    },
    ...mapState(["countries"])
  },
  methods: {
    scrollElToView: _.debounce(function() {
      let el = this.$refs.options.childNodes[this.activeOptionIndex];
      el.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
      });
    }, 200),
    keypressHandler() {
      if (!this.activeOptions) {
        this.activeOptions = true;
      }
    },
    keydownHandler() {
      if (this.activeOptionIndex < this.filteredCountries.length - 1) {
        this.activeOptionIndex++;
        this.scrollElToView();
      }
    },
    keyupHandler() {
      if (this.activeOptionIndex > 0) {
        this.activeOptionIndex--;
        this.scrollElToView();
      }
    },
    enterHandler() {
      console.log(this.activeOptionIndex, " :: ", this.filteredCountries);
      this.updateSearch(
        this.filteredCountries[Math.max(this.activeOptionIndex, 0)].title,
        true
      );
    },
    updateSearch(string, keypressed) {
      this.search = string;
      this.activeOptionIndex = -1;
      if (!keypressed) {
        this.activeOptions = false;
      } else {
        setTimeout(
          function() {
            this.activeOptions = false;
          }.bind(this),
          200
        );
      }
    },
    parseCountryLabel(title) {
      if (this.search.length) {
        let x = _.intersection(
          _.toArray(this.search.toLowerCase()),
          _.toArray(title.toLowerCase())
        ).join(""); //  title.length > this.search.length ? this.search : title;
        let rx = new RegExp(`(${x})`, "gi");
        return title.replace(rx, '<span class="text-blue-3">$1</span>');
      }
      return title;
    },
    blurHandler: _.debounce(function() {
      if (this.search.length && this.filteredCountries.length) {
        this.search = this.filteredCountries[0].title;
      }
      this.activeOptions = false;
    }, 200)
  }
};
</script>

<style lang="stylus" scoped>
.search-list
    position relative
    z-index 90
    +below(815px)
      pad('2xl', x)
      pad('xl', y)
      +portrait()
        padding-bottom 0
    input
        border none
        border-bottom 1px solid gray_3
        padding-bottom 10px
        display block
        width 100%
        &::placeholder
            color gray_3
            transition color 0.2s ease-out
        &:focus
            outline none
            &::placeholder
                color gray_2
    &--options
        position absolute
        left 0
        top 100%
        width 100%
        background #fff
        text-align left
        box-shadow 2px 2px 5px rgba(0,0,0,0.18)
        max-height 30vh
        overflow-y auto
        z-index 99
        li
            cursor pointer
            height 50px
            line-height 50px
            padding 0 25px
            transition background 0.3s ease-out
            &:hover
            &.active
                background #f6fbfe
</style>
